"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplyAura_OnEventEventHandlerScript = void 0;
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const core_2 = require("../../core/effects/core");
let ApplyAura_OnEventEventHandlerScript = class ApplyAura_OnEventEventHandlerScript {
    run(sequence, container, handler, event) {
        const { attachment, duration, target, type } = handler.args.scriptArgs;
        container.selectLivingTargets(event.subject, target)
            .forEach(targetId => {
            const vfxId = sequence.pushArgs(new core_1.AuraVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, attachment), type));
            container.applyEffect(sequence, event.subject, targetId, new core_2.LinkedVfxEffectArgs("Aura", vfxId), duration, true);
        });
    }
};
ApplyAura_OnEventEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("ApplyAura_OnEvent")
], ApplyAura_OnEventEventHandlerScript);
exports.ApplyAura_OnEventEventHandlerScript = ApplyAura_OnEventEventHandlerScript;
